if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        if (this.elements.viewer) {
            this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 300));
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', (event) => this.setActiveMedia(mediaToSwitch.dataset.target, false, event));
          });
          
          this.elements.thumbnails.querySelectorAll('.slider-button').forEach(button => {
              button.addEventListener('click', this.onThumbnailButtonClick.bind(this));
          });

          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
          this.updateThumbnailArrows();
        }
      }

      onThumbnailButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const currentThumbnailItem = this.elements.thumbnails.querySelector('.thumbnail-list__item button[aria-current="true"]')?.closest('.thumbnail-list__item');
        if (!currentThumbnailItem) return;

        let targetThumbnailItem;
        if (button.name === 'next') {
          targetThumbnailItem = currentThumbnailItem.nextElementSibling;
        } else {
          targetThumbnailItem = currentThumbnailItem.previousElementSibling;
        }

        if (targetThumbnailItem && targetThumbnailItem.querySelector('button')) {
          targetThumbnailItem.querySelector('button').click();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        
        if (thumbnail && thumbnail.querySelector('button[aria-current="true"]')) {
          return;
        }
        this.setActiveThumbnail(thumbnail);
      }
      
      setActiveMedia(mediaId, prepend, event) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        const mainSlider = this.elements.viewer.slider;
        if (mainSlider) {
          mainSlider.classList.add('slider--no-transition');
          mainSlider.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'auto'
          });
          requestAnimationFrame(() => {
            mainSlider.classList.remove('slider--no-transition');
          });
        }
        
        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
      
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        
        const thumbnailSliderContainer = this.elements.thumbnails;
        const thumbnailSlider = thumbnailSliderContainer.querySelector('.thumbnail-list');
        if (thumbnailSlider && !thumbnailSliderContainer.classList.contains('thumbnail-slider--no-slide')) {
          const targetScrollLeft = thumbnail.offsetLeft - (thumbnailSlider.clientWidth / 2) + (thumbnail.clientWidth / 2);
          thumbnailSlider.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
        }
        this.updateThumbnailArrows();
      }

      updateThumbnailArrows() {
        if (!this.elements.thumbnails) return;
        
        const prevButton = this.elements.thumbnails.querySelector('.slider-button--prev');
        const nextButton = this.elements.thumbnails.querySelector('.slider-button--next');

        if (!prevButton || !nextButton) return;
        
        const thumbnailItems = Array.from(this.elements.thumbnails.querySelectorAll('.thumbnail-list__item'));
        const activeThumbnail = thumbnailItems.find(item => item.querySelector('button[aria-current="true"]'));
        
        if (!activeThumbnail) {
          prevButton.setAttribute('disabled', true);
          nextButton.setAttribute('disabled', true);
          return;
        }

        const activeIndex = thumbnailItems.indexOf(activeThumbnail);
        
        prevButton.toggleAttribute('disabled', activeIndex === 0);
        nextButton.toggleAttribute('disabled', activeIndex === thumbnailItems.length - 1);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => { this.elements.liveRegion.setAttribute('aria-hidden', true); }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}